import React from "react";
import Blocker from "../../../../Misc/Blocker";
import Context from "../../../../../Context";
import RecursiveTreeView from "./RecursiveTreeView";
import ItemView from "./ItemView";
import CrumbsProvider from "../../../../Misc/CrumbsProvider";
export default class Areas extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItem: false,
      navigateItem: false,
      items: {},
      types: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  //Loads types and items from API
  load = async () => {
    this.setState({ pending: true });
    let result = false;

    let items = {};
    result = await this.context.api.q("/admin/area/list");

    if (result !== false) {
      if (Array.isArray(result)) {
        result.forEach((item) => {
          if (item.code === "root") item.name = "Все подразделения";
          items[item.id] = item;
        });
      }
    }

    let types = {};
    result = await this.context.api.q("/admin/area/type");
    if (result !== false) {
      if (Array.isArray(result)) {
        result.forEach((type) => (types[type.code] = type));
      }
    }

    this.setState({ pending: false, items, types });
  };

  //Handles tree navigation click
  navigate = (id) => {
    this.setState({ navigateItem: false, activeItem: id });
  };

  afterItemChange = async (id = false) => {
    await this.load();
    this.setState({ navigateItem: id, activeItem: id });
  };

  //Render layout
  render() {
    return (
      <>
        <CrumbsProvider title="Подразделения" />
        <Blocker on={this.state.pending}>
          <div className="card card-stretch  card-custom gutter-b  ">
            <div className="card-body ">{this.renderContent()}</div>
          </div>
        </Blocker>
      </>
    );
  }

  //Render contents
  renderContent() {
    let itemViewKey = this.state.pending ? "" : this.state.activeItem;
    return (
      <div className="row  h-100">
        <div className="col-lg-4    border-right mb-lg-0 mb-10">
          {this.state.pending || !this.state.items ? null : (
            <RecursiveTreeView
              expanded={Object.keys(this.state.items)}
              navigate={this.state.navigateItem}
              data={this.state.items}
              changeFn={this.navigate}
            />
          )}
        </div>
        <div className="col-lg-8">
          {this.state.pending ? null : (
            <ItemView
              data={this.state.items}
              activeItem={this.state.activeItem}
              changeFn={this.afterItemChange}
              key={itemViewKey}
              types={this.state.types}
            />
          )}
        </div>
      </div>
    );
  }
}
